"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserSaga = getUserSaga;
exports.getUserAfterSuccessSignUpSaga = getUserAfterSuccessSignUpSaga;
exports.getDefaultAccountSaga = getDefaultAccountSaga;
exports.getBetGamesTokenSaga = getBetGamesTokenSaga;
exports.getTurboGamesTokenSaga = getTurboGamesTokenSaga;
exports.fetchSMSCodeSaga = fetchSMSCodeSaga;
exports.getSportGamesTokenSaga = getSportGamesTokenSaga;
exports.getFriggTokenSaga = getFriggTokenSaga;
exports.getLiveGamesTokenSaga = getLiveGamesTokenSaga;
exports.getTwainGamesTokenSaga = getTwainGamesTokenSaga;
exports.getCasinoTokenSaga = getCasinoTokenSaga;
exports.getCurrentBetsAmountSaga = getCurrentBetsAmountSaga;
exports.fetchChangePassword = fetchChangePassword;
exports.accountHandleBackEndErrors = accountHandleBackEndErrors;
exports.checkChangeNewPassword = checkChangeNewPassword;
exports.updateCurrentUserSaga = updateCurrentUserSaga;
exports.fetchBonuses = fetchBonuses;
exports.deleteAccount = deleteAccount;
exports.fetchLoyaltySaga = fetchLoyaltySaga;
exports.getAccountId = getAccountId;
exports.getCyberbetTokenSaga = getCyberbetTokenSaga;
exports.getVSportTokenSaga = getVSportTokenSaga;
exports.fetchControlQuestionsSaga = fetchControlQuestionsSaga;
exports.accountProviderSaga = accountProviderSaga;
const effects_1 = require("redux-saga/effects");
const pickBy_1 = __importDefault(require("lodash/pickBy"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const mapValues_1 = __importDefault(require("lodash/fp/mapValues"));
const flow_1 = __importDefault(require("lodash/fp/flow"));
const slice_1 = require("./slice");
const selectors_1 = require("../LanguagesProvider/selectors");
const slice_2 = require("../SettingsProvider/slice");
const types_1 = require("./types");
const constants_1 = require("../SettingsProvider/constants");
const api_1 = require("../../api");
const errors_1 = require("../../utils/errors");
const constants_2 = require("../../constants");
const selectors_2 = require("./selectors");
const utils_1 = require("./utils");
const constants_3 = require("./constants");
function* getUserSaga({ payload }) {
    try {
        const profilesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.ProfilesApi);
        const { status, data } = yield (0, effects_1.call)(() => profilesApi.getCurrentClient());
        if (data) {
            yield (0, effects_1.put)(slice_1.accountProviderActions.setTypeAuthModal(null));
            yield (0, effects_1.put)(slice_1.accountProviderActions.getUserSuccess({ user: data }));
            yield (0, effects_1.put)(slice_1.accountProviderActions.getDefaultAccount());
            if ((payload === null || payload === void 0 ? void 0 : payload.type) !== constants_2.EAuthPagesAndModal.FastSignUp) {
                // instead getSettingsData call setSettingsData in getUserAfterSuccessSignUpSaga for set actual local settings firstly
                // setSettingsData like getSettingsData will return all changed settings
                yield (0, effects_1.put)(slice_2.settingsProviderActions.getSettingsData(payload));
            }
        }
        else {
            yield (0, effects_1.put)(slice_1.accountProviderActions.getUserError({
                code: status,
                title: data,
                reasons: [],
                message: '',
            }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching user', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getUserError(error));
    }
}
function* getUserAfterSuccessSignUpSaga() {
    yield (0, effects_1.put)(slice_1.accountProviderActions.getUser({ type: constants_2.EAuthPagesAndModal.FastSignUp }));
    const { success } = yield (0, effects_1.race)({
        success: (0, effects_1.take)(slice_1.accountProviderActions.getUserSuccess.type),
        error: (0, effects_1.take)(slice_1.accountProviderActions.getUserError.type),
    });
    if (success) {
        // User data need for request setSettingsData, where settings sending to Back-End
        const { layoutTheme } = JSON.parse(js_cookie_1.default.get(constants_1.COOKIE_USER_SETTINGS_NAME) || '');
        yield (0, effects_1.put)(slice_2.settingsProviderActions.setSettingsData({ layoutTheme }));
    }
}
function* getDefaultAccountSaga() {
    try {
        const accountsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.AccountsApi);
        const { data } = yield (0, effects_1.call)(() => accountsApi.getDefaultAccount());
        yield (0, effects_1.put)(slice_1.accountProviderActions.getDefaultAccountSuccess({ defaultAccount: data }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching the default account', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getDefaultAccountError(error));
    }
}
function* getBetGamesTokenSaga(action) {
    try {
        const virtualGamesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualGamesApi);
        const languageCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const { data: token } = yield (0, effects_1.call)(() => virtualGamesApi.createBetGamesToken({
            newVirtualGamesToken: { ...action.payload, languageCode },
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.getBetGamesTokenSuccess({ token }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching BetGames token', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getBetGamesTokenError(error));
    }
}
function* getTurboGamesTokenSaga(action) {
    try {
        const virtualGamesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualGamesApi);
        const languageCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const { data: token } = yield (0, effects_1.call)(() => virtualGamesApi.createVirtualGamesToken({
            newVirtualGamesToken: {
                ...action.payload,
                gameVendor: betweb_openapi_axios_1.VirtualGameVendor.TurboGames,
                languageCode,
            },
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.getTurboGamesTokenSuccess({ token }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching TurboGames token', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getTurboGamesTokenError(error));
    }
}
function* fetchSMSCodeSaga() {
    try {
        // TODO add API request
        yield;
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error(error);
        // TODO handle error
    }
}
function* getSportGamesTokenSaga(action) {
    try {
        const virtualGamesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualGamesApi);
        const languageCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const { data: token } = yield (0, effects_1.call)(() => virtualGamesApi.createVirtualGamesToken({
            newVirtualGamesToken: {
                ...action.payload,
                languageCode,
                gameVendor: betweb_openapi_axios_1.VirtualGameVendor.SportGames,
            },
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.getSportGamesTokenSuccess({ token }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching SportGames token', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getSportGamesTokenError(error));
    }
}
function* getFriggTokenSaga(action) {
    try {
        const virtualGamesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualGamesApi);
        const languageCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const { data: token } = yield (0, effects_1.call)(() => virtualGamesApi.createVirtualGamesToken({
            newVirtualGamesToken: {
                ...action.payload,
                languageCode,
                gameVendor: betweb_openapi_axios_1.VirtualGameVendor.Frigg,
            },
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.getFriggTokenSuccess({ token }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching Frigg token', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getFriggTokenError(error));
    }
}
function* getLiveGamesTokenSaga(action) {
    try {
        const virtualGamesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualGamesApi);
        const languageCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const { data: token } = yield (0, effects_1.call)(() => virtualGamesApi.createVirtualGamesToken({
            newVirtualGamesToken: {
                ...action.payload,
                gameVendor: betweb_openapi_axios_1.VirtualGameVendor.LiveGames,
                languageCode,
            },
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.getLiveGamesTokenSuccess({ token }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching SportGames token', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getLiveGamesTokenError(error));
    }
}
function* getTwainGamesTokenSaga(action) {
    try {
        const virtualGamesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualGamesApi);
        const languageCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const { data: token } = yield (0, effects_1.call)(() => virtualGamesApi.createVirtualGamesToken({
            newVirtualGamesToken: {
                ...action.payload,
                gameVendor: betweb_openapi_axios_1.VirtualGameVendor.TwainSport,
                languageCode,
            },
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.getTwainGamesTokenSuccess({ token }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching SportGames token', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getTwainGamesTokenError(error));
    }
}
function* getCasinoTokenSaga(action) {
    try {
        const virtualGamesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualGamesApi);
        const languageCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const { data: token } = yield (0, effects_1.call)(() => virtualGamesApi.createVirtualGamesToken({
            newVirtualGamesToken: {
                ...action.payload,
                gameVendor: betweb_openapi_axios_1.VirtualGameVendor.Casino,
                languageCode,
            },
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.getCasinoTokenSuccess({ token }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching SportGames token', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getCasinoTokenError(error));
    }
}
function* getCurrentBetsAmountSaga() {
    try {
        const betsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.BetsApi);
        const accountId = yield (0, effects_1.call)(getAccountId);
        const reqPayload = { accountId };
        const { data: { items }, } = yield betsApi.getBetsStatistics(reqPayload);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getCurrentBetsAmountSuccess({ items }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching current bets amount', error);
    }
}
function* fetchChangePassword() {
    try {
        const profilesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.ProfilesApi);
        const { password: { oldPassword, newPassword }, recaptchaToken, } = yield (0, effects_1.select)(selectors_2.selectChangePassword);
        const data = yield (0, effects_1.call)(() => profilesApi.updateCurrentClientPassword({
            clientPasswordUpdate: {
                oldPassword,
                newPassword,
                recaptchaToken,
            },
        }));
        if (data.status === 204) {
            yield (0, effects_1.put)(slice_1.accountProviderActions.fetchChangePasswordSuccess(true));
        }
        else
            yield (0, effects_1.put)(slice_1.accountProviderActions.getChangePasswordError([
                {
                    type: types_1.EChangePassword.OLD,
                    text: '',
                },
            ]));
    }
    catch (errors) {
        yield accountHandleBackEndErrors(errors);
    }
}
function* accountHandleBackEndErrors(errors) {
    const backEndErrors = [];
    if (errors.response.status === 400) {
        const backendTitleErrors = errors.response.data.errors.map(({ code }) => {
            if (code === constants_3.EAllAccountErrors.INCORRECT_OLD_PASSWORD) {
                return {
                    type: types_1.EChangePassword.OLD,
                    text: 'Invalid password',
                };
            }
            else {
                return {
                    type: types_1.EChangePassword.OLD,
                    text: '',
                };
            }
        });
        backEndErrors.push(...backendTitleErrors);
    }
    yield (0, effects_1.put)(slice_1.accountProviderActions.getChangePasswordError(backEndErrors));
}
function* checkChangeNewPassword() {
    try {
        const { password } = yield (0, effects_1.select)(selectors_2.selectChangePassword);
        const checkPassword = (0, utils_1.getCheckPassword)(password);
        if (!checkPassword.length) {
            yield (0, effects_1.put)(slice_1.accountProviderActions.setValidationErrors([]));
            yield (0, effects_1.put)(slice_1.accountProviderActions.setDisabledBtn(false));
        }
        else {
            yield (0, effects_1.put)(slice_1.accountProviderActions.setValidationErrors(checkPassword));
            yield (0, effects_1.put)(slice_1.accountProviderActions.setDisabledBtn(true));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_1.accountProviderActions.updateCurrentUserError(error));
    }
}
function* updateCurrentUserSaga() {
    try {
        const profilesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.ProfilesApi);
        const dataStepOne = yield (0, effects_1.select)(selectors_2.selectAuthenticationDataStepOne);
        const dataStepTwo = yield (0, effects_1.select)(selectors_2.selectAuthenticationDataStepTwo);
        // here we remove empty fields in object
        const clientUpdate = (0, flow_1.default)(pickBy_1.default, (0, mapValues_1.default)((value) => typeof value === 'string' ? value.trim() : value), pickBy_1.default)({ ...dataStepOne, ...dataStepTwo });
        const { data } = yield (0, effects_1.call)(() => profilesApi.updateCurrentClient({
            clientUpdate,
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.updateCurrentUserSuccess(data));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while updating current user', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.updateCurrentUserError(error));
    }
}
function* fetchBonuses() {
    var _a;
    try {
        const accountsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.AccountsApi);
        const accountId = yield (0, effects_1.select)(selectors_2.selectAccountId);
        const { data } = yield (0, effects_1.call)(() => accountsApi.getAppliedPromotions({ accountId }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.setBonuses({
            items: (_a = data.items) !== null && _a !== void 0 ? _a : [],
            hasMore: data.hasMore,
        }));
    }
    catch (error) {
        console.error('Error occurred while fetching bonuses', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.setBonuses(error));
    }
}
function* deleteAccount() {
    try {
        const profilesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.ProfilesApi);
        const { status, data } = yield (0, effects_1.call)(() => profilesApi.deleteCurrentClient());
        if (status === 204) {
            yield (0, effects_1.put)(slice_1.accountProviderActions.deleteAccountSuccess());
        }
        else {
            yield (0, effects_1.put)(slice_1.accountProviderActions.deleteAccountError({
                code: status,
                title: data,
                reasons: [],
                message: '',
            }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error(error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.deleteAccountError(error));
    }
}
function* fetchLoyaltySaga() {
    try {
        const loyaltyApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.LoyaltyApi);
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const accountId = yield (0, effects_1.select)(selectors_2.selectAccountId);
        const { data } = yield (0, effects_1.call)(() => loyaltyApi.getAppliedCoupons({
            locale,
            accountId,
            applyStatuses: [
                betweb_openapi_axios_1.AppliedCouponStatus.Created,
                betweb_openapi_axios_1.AppliedCouponStatus.Used,
                betweb_openapi_axios_1.AppliedCouponStatus.Expired,
            ],
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.fetchLoyaltySuccess(data));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error(error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.fetchLoyaltyError(error));
    }
}
function* getAccountId() {
    let accountId = yield (0, effects_1.select)(selectors_2.selectAccountId);
    if (!accountId) {
        /*
          accountId could be undefined in case it was not loaded yet
        */
        yield (0, effects_1.take)(slice_1.accountProviderActions.getDefaultAccountSuccess.type); // wait for the account to be fetched
        accountId = yield (0, effects_1.select)(selectors_2.selectAccountId);
    }
    return accountId;
}
function* getCyberbetTokenSaga({ payload, }) {
    try {
        const languageCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const virtualGamesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualGamesApi);
        const { data: { token }, } = yield (0, effects_1.call)(() => virtualGamesApi.createVirtualGamesToken({
            newVirtualGamesToken: {
                accountId: payload.accountId,
                languageCode,
                gameVendor: betweb_openapi_axios_1.VirtualGameVendor.Oddingg,
            },
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.getCyberbetTokenSuccess({ token }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching Cyberbet token', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getCyberbetTokenError(error));
    }
}
function* getVSportTokenSaga({ payload, }) {
    try {
        const languageCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const virtualGamesApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualGamesApi);
        const { data: { token }, } = yield (0, effects_1.call)(() => virtualGamesApi.createVirtualGamesToken({
            newVirtualGamesToken: {
                accountId: payload.accountId,
                languageCode,
                gameVendor: betweb_openapi_axios_1.VirtualGameVendor.BetRadarVirtualSports,
            },
        }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.getVsportTokenSuccess({ token }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching Vsport token', error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.getVsportTokenError(error));
    }
}
function* fetchControlQuestionsSaga() {
    const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
    const controlQuestionsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.ControlQuestionsApi);
    try {
        const { data } = yield (0, effects_1.call)(() => controlQuestionsApi.getControlQuestions({ locale }));
        yield (0, effects_1.put)(slice_1.accountProviderActions.setControlQuestions(data));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error(error);
        yield (0, effects_1.put)(slice_1.accountProviderActions.updateCurrentUserError(error));
    }
}
function* accountProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getUser.type, getUserSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getUserAfterSuccessSignUp.type, getUserAfterSuccessSignUpSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getDefaultAccount.type, getDefaultAccountSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getTurboGamesToken.type, getTurboGamesTokenSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getBetGamesToken.type, getBetGamesTokenSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getSportGamesToken.type, getSportGamesTokenSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getLiveGamesToken.type, getLiveGamesTokenSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getTwainGamesToken.type, getTwainGamesTokenSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getCyberbetToken.type, getCyberbetTokenSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getVsportToken.type, getVSportTokenSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getCasinoToken.type, getCasinoTokenSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getFriggToken.type, getFriggTokenSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.getCurrentBetsAmount.type, getCurrentBetsAmountSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.setChangePassword.type, checkChangeNewPassword),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.fetchChangePassword.type, fetchChangePassword),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.updateCurrentUser.type, updateCurrentUserSaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.fetchBonuses, fetchBonuses),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.deleteAccount.type, deleteAccount),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.fetchLoyalty.type, fetchLoyaltySaga),
        (0, effects_1.takeLatest)(slice_1.accountProviderActions.fetchControlQuestions.type, fetchControlQuestionsSaga),
    ]);
}
//# sourceMappingURL=saga.js.map